import React from "react";
import { UsersThree } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { initials, ROLE_LABELS } from "../lib/utils";

/**
 * Multi-select list of users (for assigning access on create).
 * `value` is an array of user ids; `onChange(nextIds)`.
 */
export default function UserMultiSelect({ users, value, onChange, placeholder = "Select users…" }) {
  const toggle = (id) =>
    onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="w-full justify-start font-normal text-sm h-9">
          <UsersThree size={14} className="mr-1.5 text-blue-600" />
          {value.length ? `${value.length} user(s) selected` : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-2" align="start">
        {users.length === 0 && <div className="text-xs text-slate-400 p-2">No assignable users.</div>}
        <div className="max-h-60 overflow-auto space-y-0.5">
          {users.map((u) => (
            <label key={u.id} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-slate-50 cursor-pointer">
              <Checkbox checked={value.includes(u.id)} onCheckedChange={() => toggle(u.id)} />
              <div className="w-6 h-6 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-[10px] font-semibold">{initials(u.name)}</div>
              <div className="min-w-0">
                <div className="text-sm text-slate-700 truncate">{u.name}</div>
                <div className="text-[10px] text-slate-400">{ROLE_LABELS[u.role]}</div>
              </div>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
